import styles from "./styles.scss";
import IconMessage from "../../assets/icons/icon-message.svg";

const FAB = ({ onClick, className = "" }) => (
  <button className={`${className} ${styles.fab}`} onClick={onClick}>
    <IconMessage className={styles.fabIcon} />
  </button>
);

export default FAB;



// WEBPACK FOOTER //
// ./components/fab/index.js